module.exports = __webpack_public_path__ + "static/media/STATREP - Mt Vernon.099e76bc.pdf";